//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDelControl', {
//        templateUrl: 'views/components/views/batchDelControl/batchDelControl.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'modalService', 'stateService', 'utilityService', 'translateService', 'rememberService', 'batchDelControlService', function ($stateParams, modalService, stateService, utilityService, translateService, rememberService, batchDelControlService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDeliveryKeyno = $stateParams.batchdelivery_keyno;
//            let purchInternalNo = $stateParams.purch_internal_no;

//            let variableNames = {
//                searchtext: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgBatchDelControl: {
//                    selected: 'COLLI',
//                    buttons: [
//                        { id: 'COLLI', label: 'bg_batchdelcontrol_colli', color: 'primary', onClick: () => vm.model.bgBatchDelControl.selected = 'COLLI' },
//                        { id: 'SKU', label: 'bg_batchdelcontrol_sku', color: 'primary', onClick: () => vm.model.bgBatchDelControl.selected = 'SKU' }
//                    ]
//                },
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                itemsListControls: [],
//                itemsListSkus: [],
//                lockedApprove: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await batchDelControlService.getSetting({
//                    batchdelivery_keyno: batchDeliveryKeyno,
//                    purch_internal_no: purchInternalNo
//                }))[0];
//            }

//            async function loadControls() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                return vm.model.itemsListControls = await batchDelControlService.listControls(vm.model.setting);
//            }

//            async function loadSkus() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                return vm.model.itemsListSkus = await batchDelControlService.listSkus(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgBatchDelControl = function (value) {
//                vm.model.bgBatchDelControl.selected = value;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.approveChanges = function () {
//                vm.model.lockedApprove = true;

//                batchDelControlService.approveControl(vm.model.setting).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedApprove = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedApprove = false;
//                        stateService.back('/batchdelivery/' + vm.model.setting.batchdelivery_keyno);
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadControls();
//                loadSkus();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
